// components/Header/ThemeToggle.jsx
import React from 'react';
import { IconButton, MenuItem, Box, Switch } from '@mui/material';
import { Sun, Moon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../context/ThemeContext';

export const ThemeToggleButton = ({ size = 22 }) => {
  const { isDark, toggleTheme } = useTheme();

  return (
    <IconButton
      onClick={toggleTheme}
      sx={{
        // Adapt to header background
        color: isDark ? 'text.primary' : 'inherit',
        '&:hover': {
          bgcolor: isDark 
            ? 'action.hover' 
            : 'rgba(255, 255, 255, 0.1)',
        },
      }}
    >
      {isDark ? <Sun size={size} /> : <Moon size={size} />}
    </IconButton>
  );
};

export const ThemeToggleMenuItem = ({ onToggle }) => {
  const { t } = useTranslation();
  const { isDark, toggleTheme } = useTheme();

  const handleClick = (e) => {
    e.stopPropagation();
    toggleTheme();
    onToggle?.();
  };

  return (
    <MenuItem
      onClick={handleClick}
      sx={{
        fontFamily: 'Inter, sans-serif',
        fontWeight: 500,
        py: 1.25,
        display: 'flex',
        justifyContent: 'space-between',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {isDark ? (
          <Moon size={18} style={{ marginRight: 8 }} />
        ) : (
          <Sun size={18} style={{ marginRight: 8 }} />
        )}
        {t('theme.darkMode') || 'Dark Mode'}
      </Box>
      <Switch
        size="small"
        checked={isDark}
        onChange={toggleTheme}
        onClick={(e) => e.stopPropagation()}
      />
    </MenuItem>
  );
};